/*
 * @Date: 2023-02-14 09:56:13
 * @LastEditTime: 2026-01-31 10:00:00
 * @Description: 线上课程API - 同步小程序端功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 获取课程列表（分页）
  getOnlineCoursePageList(data) {
    return request({
      url: "/online_course/getCoursePageList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取课程详情
  getOnlineCourseDetail(data) {
    return request({
      url: "/online_course/getCourseDetail?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取线上课列表（首页分类）
  getOnlineCourseList(data) {
    return request({
      url: "/online_course/getCourseList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取课程评价
  getOnlineCourseEvaluate(data) {
    return request({
      url: "/online_course/getCourseEvaluate?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取评价详情
  getEvaluateDetail(data) {
    return request({
      url: "/online_course/getEvaluateDetail?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 专属推荐课
  getRecommendCourse(data) {
    return request({
      url: "/online_course/getRecommendCourse?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 查询订单状态
  getOrder(data) {
    return request({
      url: "/online_course/getOrder?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 新增订单
  addOrder(data) {
    return request({
      url: "/online_course/addOrder",
      method: "post",
      data,
    });
  },
  // 更新订单状态
  updateOrder(data) {
    return request({
      url: "/online_course/updateOrder",
      method: "post",
      data,
    });
  },
  // 课程评价点赞/取消点赞
  evaluateLike(data) {
    return request({
      url: "/evaluate/evaluateLike",
      method: "post",
      data,
    });
  },
  // 收藏课程/取消收藏
  courseCollect(data) {
    return request({
      url: "/course_collect/courseCollect",
      method: "post",
      data,
    });
  },
  // 评价课程
  courseEvaluate(data) {
    return request({
      url: "/evaluate/courseEvaluate",
      method: "post",
      data,
    });
  },
  // 播放记录
  addPlayHistory(data) {
    return request({
      url: "/online_course/addPlayHistory",
      method: "post",
      data,
    });
  },
  // 学习记录
  addStudyRecord(data) {
    return request({
      url: "/online_course/addStudyRecord",
      method: "post",
      data,
    });
  },
  // 获取连接ID(sse) - 已迁移到sse.js
  // getConnectId 和 wsSendBarrage 已废弃，使用 sse.js 中的 getSseConnectId 和 sseSendBarrage
};
